const comments = [
  {
    id: 1,
    name: '影迷小张',
    avatar: 'Z',
    text: '极速影视真的太绝了！院线刚下映的片子这里就能看到高清版，而且完全不卡顿，画质清晰度比我想象的好太多了，已经推荐给身边所有朋友了。',
    movie: '《星际迷航：新纪元》',
    time: '2小时前',
  },
  {
    id: 2,
    name: '电影控阿琳',
    avatar: 'A',
    text: '用了好几个在线观影平台，极速影视是加载最快的。周末一口气刷了四部大片，全程没有缓冲，1080P画质配合大屏看简直享受。',
    movie: '《热血拳王》',
    time: '5小时前',
  },
  {
    id: 3,
    name: '深夜影评人',
    avatar: 'S',
    text: '作为一个阅片无数的老影迷，极速影视的片库覆盖率和更新速度让我很惊喜。很多冷门佳片都能找到，而且分类清晰，找片超方便。',
    movie: '《古城谜案》',
    time: '8小时前',
  },
  {
    id: 4,
    name: '追剧小能手',
    avatar: 'Z',
    text: '以前总找不到高清资源，极速影视简直就是救星！最新院线大片同步更新，还有好多经典老片的高清修复版，收藏量已经破百了。',
    movie: '《深海奇缘》',
    time: '12小时前',
  },
  {
    id: 5,
    name: '周末影咖',
    avatar: 'Y',
    text: '极速影视的体验真的没话说，手机端和电脑端都很流畅。周末窝在家看了一整天的电影，完全没有广告打扰，这才是真正的观影自由。',
    movie: '《极速追击》',
    time: '1天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">影迷热评</h2>
          <p className="text-sm text-foreground-500">来看看影迷们对极速影视的真实评价</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.slice(0, 3).map((comment) => (
            <div key={comment.id} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center text-foreground-950 font-bold text-sm">
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-2">{comment.text}</p>
              <span className="text-xs text-accent-600 font-medium">正在看 {comment.movie}</span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {comments.slice(3, 5).map((comment) => (
            <div key={comment.id} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-500 flex items-center justify-center text-foreground-950 font-bold text-sm">
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-2">{comment.text}</p>
              <span className="text-xs text-accent-600 font-medium">正在看 {comment.movie}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}